function zipcodeSearch() {
  const searchBtn = document.getElementById('searchBtn');

  if (!searchBtn) {
    console.error('searchBtn が見つかりませんでした');
    return;
  }

  searchBtn.addEventListener('click', () => {
    const zip = document.getElementById('zipcode').value;
    const addressElem = document.getElementById('address');
    const errorElem = document.getElementById('errorMessage');

    addressElem.value = '';
    errorElem.textContent = '';

    if (!/^\d{7}$/.test(zip)) {
      errorElem.textContent = '7桁の数字を入力してください。';
      return;
    }

    fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${zip}`)
      .then(response => response.json())
      .then(data => {
        if (data.results) {
          const result = data.results[0];
          const fullAddress = `${result.address1}${result.address2}${result.address3}`;
          addressElem.value = fullAddress;
        } else {
          errorElem.textContent = 'その郵便番号は見つかりませんでした。';
        }
      })
      .catch(() => {
        errorElem.textContent = '住所の取得中にエラーが発生しました。';
      });
  });
}

export default zipcodeSearch;